import React from 'react';
import { FormattedDate } from 'react-intl';
import { getDateWithTimeFromSlotDetails, getFormattedTime } from "../../Utils/DateHelper";
export var getFormatedTimeSlot = function getFormatedTimeSlot(slotDetails, siteCode) {
  var isglobalTimeRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var date = getDateWithTimeFromSlotDetails(slotDetails);
  var time = getFormattedTime(slotDetails.slot, siteCode, isglobalTimeRequired);
  return {
    date: /*#__PURE__*/React.createElement(FormattedDate, {
      value: date,
      weekday: "short",
      month: "short",
      year: "numeric",
      day: "2-digit"
    }),
    time: time
  };
};
export var getDaysLeft = function getDaysLeft(slotDetails) {
  var _ref = slotDetails || {},
    _ref$date = _ref.date,
    date = _ref$date === void 0 ? '' : _ref$date,
    _ref$slot = _ref.slot,
    slot = _ref$slot === void 0 ? '' : _ref$slot;
  if (!slot) {
    return 0;
  }
  var timeArr = slot.split(':').map(function (item) {
    return parseInt(item, 10);
  });
  var oneDay = 24 * 60 * 60 * 1000;
  var dateArr = date.split('-').map(function (item) {
    return parseInt(item, 10);
  });
  var firstDate = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], timeArr[0], timeArr[1], timeArr[2]);
  var secondDate = Date.now();
  var diffDays = Math.abs((firstDate.getTime() - secondDate) / oneDay);
  return diffDays >= 1 ? Math.floor(diffDays) : 0;
};